import { render } from "./WorksView.vue?vue&type=template&id=744fd46b"
const script = {}

import exportComponent from "C:\\Users\\shiyu\\local_document\\projects\\vue\\hsmkai.github.io\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__